"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellEnhanceText = void 0;
const core_1 = require("@apitable/core");
const react_1 = __importDefault(require("react"));
const cell_email_1 = require("../cell_email");
const cell_text_1 = require("../cell_text");
const cell_url_1 = require("../cell_url");
const CellEnhanceText = (props) => {
    const { text, cellClassName, cellStyle } = props;
    if (!text) {
        return null;
    }
    const enhanceTexts = (0, core_1.string2Segment)(text);
    return (react_1.default.createElement("div", { className: cellClassName, style: cellStyle }, enhanceTexts.map((enhanceText, index) => {
        if (enhanceText.type === core_1.SegmentType.Url) {
            return react_1.default.createElement(cell_url_1.CellUrl, { key: index, value: enhanceText.link });
        }
        if (enhanceText.type === core_1.SegmentType.Email) {
            return react_1.default.createElement(cell_email_1.CellEmail, { key: index, value: enhanceText.link });
        }
        return react_1.default.createElement(cell_text_1.CellText, { key: index, text: enhanceText.text });
    })));
};
exports.CellEnhanceText = CellEnhanceText;
